import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Récupérer la langue sauvegardée ou utiliser 'en' par défaut
const savedLanguage = localStorage.getItem('i18n_language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Sauvegarder la langue à chaque changement
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18n_language', lng);
  document.documentElement.lang = lng;
});

// Définir la langue initiale sur le document
document.documentElement.lang = savedLanguage;

export default i18n;
